import { IntlProvider } from 'react-intl';
import messages_en from '@/locales/en.json';
import messages_es from '@/locales/es.json';
import messages_bg from '@/locales/bg.json';
import { createContext, useEffect, useState } from 'react';


// English is the source catalogue; every other locale is layered on top of it,
// so a key that has not been translated yet renders its English string instead
// of the raw message id. What react-intl still reports as a missing translation
// is then an id absent from en.json itself: a real bug, so its default error
// handler stays on. Built once here, not per render: IntlProvider rebuilds its
// formatters whenever the messages object changes identity.
const messages = {
    en: messages_en,
    es: { ...messages_en, ...messages_es },
    bg: { ...messages_en, ...messages_bg },
}

export const LanguageContext = createContext();
const supportedLanguages = ["en", "es", "bg"];

export const LanguageProvider = ({ children }) => {
    const defaultLang = () => localStorage.getItem('locale') || (supportedLanguages.includes(navigator.language.split(/[-_]/)[0]) ? navigator.language.split(/[-_]/)[0] : 'en');
    const [locale, setLocale] = useState(defaultLang);
    useEffect(() => {
        localStorage.setItem('locale', locale);
    }, [locale]);
    return (
        <LanguageContext.Provider value={{ locale, setLocale }}>
            <IntlProvider locale={locale} messages={messages[locale] ?? messages.en}>
                {children}
            </IntlProvider>
        </LanguageContext.Provider>
    );
}
